export default function KeyIcon({ className }) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20.667 10.0003L25.3337 5.33366M28.0004 2.66699L25.3337 5.33366L28.0004 2.66699ZM15.187 15.4803C15.8755 16.1596 16.4228 16.9684 16.7974 17.86C17.172 18.7517 17.3665 19.7087 17.3697 20.6758C17.373 21.643 17.1849 22.6012 16.8163 23.4954C16.4476 24.3896 15.9058 25.202 15.2219 25.8859C14.538 26.5697 13.7256 27.1116 12.8314 27.4802C11.9373 27.8488 10.979 28.0369 10.0119 28.0337C9.04472 28.0305 8.08776 27.8359 7.19609 27.4613C6.30442 27.0867 5.49565 26.5394 4.81637 25.851C3.48054 24.4679 2.74138 22.6155 2.75809 20.6927C2.7748 18.7699 3.54604 16.9306 4.9057 15.571C6.26536 14.2113 8.10465 13.4401 10.0274 13.4234C11.9502 13.4067 13.8026 14.1458 15.1857 15.4817L15.187 15.4803ZM15.187 15.4803L20.667 10.0003L15.187 15.4803ZM20.667 10.0003L24.667 14.0003L29.3337 9.33366L25.3337 5.33366L20.667 10.0003Z"
        stroke="inherit"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
